export const TeleportBtnIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.54069 11.998C5.54069 8.43063 8.43259 5.53874 11.9999 5.53874M5.54069 11.998C5.54069 15.5653 8.43259 18.4572 11.9999 18.4572M5.54069 11.998L3.69519 11.998M11.9999 5.53874C15.5673 5.53874 18.4592 8.43064 18.4592 11.998M11.9999 5.53874L11.9999 3.69324M11.9999 18.4572C15.5673 18.4572 18.4592 15.5653 18.4592 11.998M11.9999 18.4572L11.9999 20.3027M18.4592 11.998L20.3047 11.998M9.23169 11.998C9.23169 10.4691 10.471 9.22974 11.9999 9.22974C13.5288 9.22974 14.7682 10.4691 14.7682 11.998C14.7682 13.5269 13.5288 14.7662 11.9999 14.7662C10.471 14.7662 9.23169 13.5269 9.23169 11.998Z"
        stroke="#2055FF"
        strokeWidth="1.81195"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
